export const overrides = {
    MuiToggleButtonGroup: {
        root: {
            '&[class*="NeptuneToggleButtonGroup"]': {
                display: 'flex',
                borderRadius: 6,

                '& .MuiToggleButton-root': {
                    flexGrow: 1,
                    textTransform: 'none'
                }
            }
        }
    }
};
